/* Sample Kit PDP — small shared behaviours.
   Any element with data-skp-scroll-to smooth-scrolls to the first match of its
   selector; falling back to the first buy box on the page so CTAs keep working
   even if the merchant reorders sections. */
(function () {
  'use strict';

  // This file is emitted by every instance of its section, so it can be
  // executed several times on one page. Bind once; later copies bail out.
  if (window.__skpUiInit) return;
  window.__skpUiInit = true;

  function target(el) {
    var sel = el.getAttribute('data-skp-scroll-to');
    var node = null;
    if (sel && sel !== 'buy-box') {
      try { node = document.querySelector(sel); } catch (e) { node = null; }
    }
    return node || document.querySelector('[data-skp-buy-box]');
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-skp-scroll-to]');
    if (!trigger) return;
    var node = target(trigger);
    if (!node) return;
    e.preventDefault();
    node.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
})();
